<div class="modal-header">
  <h4 class="modal-title h1 pull-left">Delete {{ title }}</h4>
  <btn-close class="pull-right" (click)="modalRef.hide()"></btn-close>
</div>
<div class="modal-body">
  <p>Are you sure you want to delete {{ name }} ?<br>
    <span class="small small-text">Please type the following to confirm:<br>
      <code class="badge badge-dark">{{ name }}</code>
    </span>
  </p>
  <form [formGroup]="form" (submit)="_delete()">
    <input class="form-control" type="text"
           validate popper formControlName="name">
  </form>
</div>
<div class="modal-footer border-0" [formGroup]="form" (submit)="delete()">
  <button class="btn btn-danger mr-2"
          type="submit"
          [disabled]="notEqual"
          (click)="_delete()">Delete</button>
  <button class="btn btn-outline-info" (click)="this.modalRef.hide(); cancel()">Cancel</button>
</div>
